<template>
  <div>
    <button  type="button" @click="openUpload()"   class="forward">
      انتخاب عکس
    </button>
    <button  type="button" @click="uploadData()" class="forward">
      {{!loading?'بارگذاری':'در حال ارسال'}}
       
    </button>
		<div v-if="path">
      <img :src="path" style="max-width:300px" />
		</div>
  </div>
</template>




<script>
export default {
  name:"uploader",
  props:{
    "value":{default:""},
    "item":{default:{}},
    "questionId":{default:""},
  },
  data() {
    return {
      path:'',
      loading:false
    }
  },
  methods: {
    setIsPicture :function(isImg)
    {
      this.item.isPicture=isImg
      this.openUpload()
    },
    upload:function (){
      var el=document.getElementById('media') //this.getElementByRef('chartid')
        var fd = new FormData(); 
        fd.append("media", el.files[0]);

        var oReq = new XMLHttpRequest();
        var t= getCookie('token') 
        this.loading=true;
        oReq.open("POST", global1.apiPath+"/v1/a/upload/"+this.questionId, false);
        oReq.setRequestHeader('x-auth-token', t); 
        oReq.send(fd);
        this.loading=false;
        return JSON.parse( oReq.responseText ); 
    },
    uploadData:function(){
      var data=this.upload()
      if(data.length)
      {
        this.path=global1.apiPath+'/'+data[0].path;
        this.$emit('input',global1.apiPath+'/'+data[0].path) 
      }

    },
    setIsPictureQue:function (isImg){
      if(this.tmpWel)
      {
        this.tmpQue.isPicture=isImg
        this.openUpload() 
      }
    },
    openUpload:function (){

        $("#media").click();
       
    },
  },
}
</script>